import { MenuItem } from "primereact/menuitem";
import { AUTH_URL_PROTOCOL } from "../cognito/authConfig";
import { useNavigate } from "react-router-dom";
import { IdwalSideBar, SidebarIcon } from "@idwal/idwal-react-components";
import { useTranslation } from "react-i18next";

export const InspectionSideBar = (props: {
    sideBarOpen: boolean;
    setSideBarOpen: (open: boolean) => void;
    inspectionType?: string;
    isIdUser: boolean;
}) => {
    const { t } = useTranslation("locale");
    const navigate = useNavigate();
    const idwalSidebarIconStyle =
        "width: 26px; height: 26px; margin-right: 0.4rem; margin-left: -0.25rem";
    const vesselsIconSidebarIconStyle =
        "width: 22px; height: 22px; margin-right: 0.4rem; margin-left: -0.25rem";
    const idConditionTypeString = "ID Condition Inspection";
    const preSaleTypeString = "Pre-Sale Inspection";

    const getCustomerPortalLinks = () => {
        if (props.inspectionType == idConditionTypeString) {
            return undefined;
        }

        return `${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_CUSTOMER_PORTAL_URL}/customer/inspection?sortOrder=log_date_desc`;
    };

    const preSaleItem = [
        {
            label: t("side_bar.pre_sale_dashboard"),
            icon: "pi pi-th-large",
            command: () => navigate("/"),
            url: `${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_PRE_SALE_URL}`
        }
    ];

    const getSideBarItems = () => {
        const items = [];

        if (props.isIdUser) {
            items.push([
                {
                    label: "My Fleet",
                    icon: (
                        <SidebarIcon
                            src={"/vessels.svg"}
                            fill={"#555555"}
                            style={vesselsIconSidebarIconStyle}
                        />
                    ),
                    command: () => navigate("/"),
                    url: `${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_FLEET_DOMAIN}.idwalmarine.com/myfleet`
                },
                {
                    label: "Grade",
                    icon: (
                        <SidebarIcon
                            src={"/scatter-icon.svg"}
                            fill={"#555555"}
                            style={idwalSidebarIconStyle}
                        />
                    ),
                    command: () => navigate("/"),
                    url: `${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_FLEET_DOMAIN}.idwalmarine.com/grade`
                },
                {
                    label: "Sub Grades",
                    icon: (
                        <SidebarIcon
                            src={"/horizontal-bar-icon.svg"}
                            fill={"#555555"}
                            style={idwalSidebarIconStyle}
                        />
                    ),
                    command: () => navigate("/"),
                    url: `${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_FLEET_DOMAIN}.idwalmarine.com/subgrades`
                },
                {
                    label: "Defects",
                    icon: "pi pi-exclamation-triangle",
                    command: () => navigate("/"),
                    url: `${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_FLEET_DOMAIN}.idwalmarine.com/defects`
                }
            ]);
        }

        return items;
    };

    return (
        <IdwalSideBar
            idSidebarItems={getSideBarItems().flat()}
            otherSideBarItems={
                props.inspectionType == preSaleTypeString ? preSaleItem : []
            }
            customerPortalLink={getCustomerPortalLinks()}
            logoutLink={`${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_AUTH_URL}/logout?redirect=${AUTH_URL_PROTOCOL}://${process.env.REACT_APP_FLEET_DOMAIN}.idwalmarine.com`}
            visible={props.sideBarOpen}
            onClose={() => {
                props.setSideBarOpen(false);
            }}
        />
    );
};
